import React from "react";
import Router from "react-router";
import { MenuItem, Drawer, Divider, Paper } from "material-ui";
import * as ColorManipulator from "material-ui/utils/colorManipulator";
import {
  colors as Colors,
  spacing as Spacing,
  typography as Typography
} from "material-ui/styles";
import assign from "lodash/assign";
import { capitalize, isApp } from "../util";
import ResizableMenu from "./partials/resizable-menu.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import PersonActions from "../actions/PersonActions";
import FilmStore from "../stores/FilmStore";

class AppLeftNav extends React.Component {
  constructor() {
    super();

    this.state = {
      open: false,
      menuItems: []
    };

    this.getStyles = this.getStyles.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this._getSelectedIndex = this._getSelectedIndex.bind(this);
    this._onLeftNavChange = this._onLeftNavChange.bind(this);
    this._onHeaderClick = this._onHeaderClick.bind(this);
    this._accountManagement = this._accountManagement.bind(this);

    this._makeMenuItems = this._makeMenuItems.bind(this);
  }

  getStores() {
    return [PersonStore, FilmStore];
  }

  getPropsFromStores() {
    let state = PersonStore.getState();
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      muiTheme: React.PropTypes.object,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  componentDidMount() {
    const stores = this.getStores(this.props, this.context);
    this.storeListeners = stores.map(store => {
      return store.listen(this.onChange);
    });
    if (this.componentDidConnect) {
      this.componentDidConnect(this.props, this.context);
    }
    this.onChange();
  }

  componentWillUnmount() {
    this.storeListeners.forEach(unlisten => unlisten());
  }

  onChange() {
    this.setState(this.getPropsFromStores(this.props, this.context));
  }

  _makeMenuItems() {
    let configuredSocialMediaProfiles = Object.keys(
      this.context.tenant.social_media
    ).filter(k => this.context.tenant.social_media[k]);
    let styles = this.getStyles();
    let items = []
      .concat(
        this.context.tenant.include_welcome_page
          ? [{ route: "/welcome", text: "Welcome" }]
          : []
      )
      .concat(
        this.context.tenant.menu_show_schedule
          ? [
              {
                route: "/schedule",
                text: capitalize(this.context.tenant.display_schedule)
              }
            ]
          : []
      )
      .concat(
        this.context.tenant.menu_show_film_guide &&
          this.context.appSettings.film_guide_enabled
          ? [
              {
                route: "/films",
                text: capitalize(
                  (this.context.tenant.display_film_guide || "").replace(
                    /film guide/i,
                    "Film Guide" // title case
                  )
                )
              }
            ]
          : []
      )
      .concat(
        this.context.appSettings.credits_enabled
          ? this.state.isLoggedIn
            ? [{ route: `/credits`, text: `My Credits` }]
            : [{ route: `/credits`, text: `Credits` }]
          : []
      )
      .concat(
        this.context.tenant.passes_enabled
          ? this.state.isLoggedIn
            ? [
                {
                  route: `/${this.context.tenant.passes_url_pathname}`,
                  text: `My ${capitalize(
                    this.context.tenant.display_passes,
                    true
                  )}`
                }
              ]
            : !isApp()
            ? [
                {
                  route: `/${this.context.tenant.passes_url_pathname}/buy`,
                  text: `${capitalize(
                    this.context.tenant.display_passes,
                    true
                  )}`
                }
              ]
            : []
          : []
      )
      .concat(
        this.context.tenant.menu_show_my_tickets
          ? [{ route: "/tickets", text: "My Tickets" }]
          : []
      )
      .concat(
        isApp()
          ? []
          : this.context.appSettings.donations_enabled
          ? [{ route: "/donate", text: this.context.tenant.donate_page_title }]
          : []
      )
      .concat(
        this.context.tenant.gift_cards_enabled && this.context.tenant.gift_cards_frontend_enabled
          ? [{ route: "/giftcards", text: "Gift Cards" }]
          : []
      )
      .concat(
        this.context.tenant.additional_routes
          .filter(r => r.path && !r.hide_in_menu)
          .map(r => {
            return { route: r.path, text: r.display_name };
          })
      )
      .concat(
        this.context.tenant.left_nav_menu_items.map(r => {
          return { isLink: true, route: r.link, text: r.label };
        })
      )
      .concat(
        configuredSocialMediaProfiles.length
          ? [
              { isDivider: true },
              {
                isSubheader: true,
                text:
                  this.context.tenant.social_media_section_header ||
                  `Connect with ${this.context.tenant.display_short_name}`
              }
            ].concat(
              configuredSocialMediaProfiles.map(k => {
                let route;

                if (k === "youtube") {
                  // YouTube-only, expect full URL
                  route = this.context.tenant.social_media[k];
                  k = "YouTube"; // fix caps
                } else {
                  route = `https://${k}.com/${this.context.tenant.social_media[k]}`;
                }

                return { isLink: true, route: route, text: capitalize(k) };
              })
            )
          : []
      );
    return items.map((x, i) => {
      if (x.isDivider) {
        return <Divider key={i} />;
      }

      let item = (
        <MenuItem
          key={i}
          style={assign(
            {},
            styles.menuItem,
            x.isSubheader ? styles.subheaderMenuItem : {},
            x.isFirst ? styles.subheaderFirstMenuItem : {},
            !x.isSubheader && !x.isLink && this.context.router.isActive(x.route)
              ? styles.menuItemActive
              : {}
          )}
          innerDivStyle={styles.menuItemInner}
          primaryText={x.text}
          onClick={
            x.isSubheader
              ? () => {}
              : () => this._onLeftNavChange(null, null, x)
          }
          disabled={x.isSubheader}
        />
      );

      if (x.isLink) {
        return (
          <a key={i} style={styles.menuItem} href={x.route} target="_blank">
            {item}
          </a>
        );
      } else {
        return item;
      }
    });
  }

  getStyles() {
    const invert =
      this.context.tenant.invert_colors ||
      this.context.tenant.invert_colors_alt;

    return {
      a: {
        textDecoration: "underline",
        cursor: "pointer"
      },
      header: {
        marginBottom: 8
      },
      title: {
        cursor: "pointer",
        fontSize: 24,
        color: invert ? "#000" : Typography.textFullWhite,
        fontWeight: Typography.fontWeightLight,
        backgroundColor: this.context.tenant.palette.primary1Color,
        lineHeight: "26px",
        padding: "19px 24px"
      },
      person: {
        padding: "10px 24px",
        backgroundColor:
          this.context.tenant.palette.primary1Color === "#ffffff"
            ? "rgba(0,0,0,0.08)"
            : ColorManipulator.fade(
                this.context.tenant.palette.primary1Color,
                0.7
              ),
        color: invert ? "#000" : Typography.textFullWhite
      },
      menu: {
        overflowY: "auto",
        overflowX: "hidden",
        height: "100%"
      },
      menuItem: {
        cursor: "pointer",
        textDecoration: "none",
        fontSize: "13px",
        color: this.context.muiTheme.rawTheme.palette.textColor
      },
      menuItemActive: {
        color: this.context.tenant.invert_colors_alt
          ? "#fff"
          : invert
          ? "#000"
          : this.context.tenant.palette.accent1Color,
        backgroundColor: invert
          ? this.context.tenant.palette.accent1Color
          : undefined,
        fontWeight: "400"
      },
      menuItemInner: {
        padding: "0 24px"
      },
      subheaderMenuItem: {
        color: invert ? "#000" : this.context.tenant.palette.primary1Color,
        fontWeight: "500",
        fontSize: "13px",
        cursor: "inherit",
        lineHeight: 1.5,
        marginTop: 24,
        marginBottom: 12,
        minHeight: "inherit",
        whiteSpace: "inherit"
      }
    };
  }

  componentWillReceiveProps(props) {
    if (this.props.docked !== props.docked) {
      this.setState({ open: props.docked ? true : false });
    }
  }

  render() {
    var styles = this.getStyles(),
      header = (
        <div style={styles.header}>
          <div style={styles.title} onClick={this._onHeaderClick}>
            {this.context.tenant.display_short_name}
          </div>
          {this.state.isLoggedIn && this.state.details ? (
            <div style={styles.person}>
              <div>{`Logged in as ${
                this.state.details.name || this.state.details.email
              }`}</div>
              <div>
                {"("}
                <a style={styles.a} onClick={this._logout}>
                  logout
                </a>
                {" · "}
                <a style={styles.a} onClick={this._accountManagement}>
                  account management
                </a>
                {")"}
              </div>
            </div>
          ) : null}
        </div>
      );

    return (
      <Drawer
        ref={leftNav => (this._leftNav = leftNav)}
        docked={this.props.docked}
        disableSwipeToOpen={true}
        selectedIndex={this._getSelectedIndex()}
        onRequestChange={e => this.close()}
        open={this.state.open}
        containerStyle={{
          overflow: "hidden",
          didFlip: true
        }}
      >
        {header}
        <ResizableMenu style={styles.menu}>
          {this._makeMenuItems()}
        </ResizableMenu>
      </Drawer>
    );
  }

  toggle() {
    this.setState({ open: !this.state.open });
  }

  open() {
    if (!this.state.open) {
      this.setState({ open: true });
    }
  }

  close() {
    this.setState({ open: false });
  }

  _logout() {
    PersonActions.logout();
  }

  _accountManagement() {
    this.context.router.push("/account");
    this.setState({ open: false });
  }

  _getSelectedIndex() {
    var currentItem,
      menuItems = this._makeMenuItems();

    for (var i = menuItems.length - 1; i >= 0; i--) {
      currentItem = menuItems[i];
      if (currentItem.route && this.props.router.isActive(currentItem.route))
        return i;
    }
  }

  _onLeftNavChange(e, key, payload) {
    if (payload.isLink) {
      return;
    }
    this.context.router.push(payload.route);
    this.setState({ open: false });
  }

  _onHeaderClick() {
    if (!this.props.docked) {
      this.context.router.push("/");
      this.setState({ open: false });
    }
  }
}

export default AppLeftNav;
AppLeftNav.toggle = (() => {
  this.setState({ open: false });
}).bind(AppLeftNav);



// WEBPACK FOOTER //
// ./src/app/components/app-left-nav.jsx